<script lang="ts">
	import queryString from "query-string";
	import { navigate } from "svelte-routing";

	import { auth } from "@hitit/hub/src/stores";
	import LoadingLayout from "../layouts/LoadingLayout.svelte";

	let error: string | undefined;
	let parsed: ReturnType<typeof queryString.parse> = {};
	let code: string | undefined;

	if (window) parsed = queryString.parse(window.location.search);
	if (typeof parsed["code"] === "string") {
		code = parsed["code"];
	}

	if (!code) {
		error = "hub.login.error.bad_approach";
	} else {
		$auth
			.grantCode(code)
			.then(() => navigate("/store"))
			.catch(() => (error = "hub.login.error.login_failed"));
	}
</script>

<LoadingLayout
	error={error}
	errorAction={"hub.login.redirect"}
	on:click={() =>
		navigate(
			`${"HITIT_BACKEND_URL"}oauth/authorize?response_type=code&client_id=web&redirect_uri=${"HITIT_HUB_URL"}login&scope=CLIENT`
		)}
/>
